module.exports = __webpack_public_path__ + "static/NightInTheWoods5-7bdd000a876a8b510b61a6b271c3f793.webp";